var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": false,
              "show-creditor-statement": true,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("creditor-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _c("subtitle-totals", {
                      attrs: {
                        labels: ["Total Balance", "Total Inv. Incl. GST"],
                        totals: [_vm.sumBalance, _vm.sumTotalIncGst],
                        shows: [true, true],
                      },
                    }),
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entitySummaries, function (entity, index) {
                          return _c(
                            "tr",
                            {
                              key: entity.creditorInvoiceId,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onVeiwInvoice(
                                          entity.creditorInvoiceId,
                                          entity.invoiceType,
                                          entity.invoiceRef,
                                          entity.purchaseOrderID
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(entity.invoiceRef))]
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.creditorName))]),
                              _c("td", { staticClass: "has-text-left" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimezone(
                                      entity.invoiceDate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-left" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimezone(
                                      entity.due,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.balance,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.totalAmount,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.gstAmount,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.amount,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-left" }, [
                                _vm._v(_vm._s(entity.purchaseOrderNo)),
                              ]),
                              _c("td", { staticClass: "has-text-left" }, [
                                entity.quoteDeleted
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "icon has-text-danger tooltip is-tooltip-danger",
                                        staticStyle: { "padding-right": "3px" },
                                        attrs: {
                                          "data-tooltip":
                                            "Quote has been deleted.",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "mdi mdi-alert mdi-18px",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" " + _vm._s(entity.quoteNo) + " "),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm._v(
                                  _vm._s(_vm.$filters.formatABN(entity.abn))
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "icon",
                                    class: [
                                      entity.exported
                                        ? "has-text-success"
                                        : "has-text-danger",
                                    ],
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-24px",
                                      class: [
                                        entity.exported ? "mdi-check" : "",
                                      ],
                                    }),
                                  ]
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-primary is-small is-inverted tooltip",
                                    attrs: { "data-tooltip": "Click to view" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onVeiwInvoice(
                                          entity.creditorInvoiceId,
                                          entity.invoiceType,
                                          entity.invoiceRef,
                                          entity.purchaseOrderID
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-file-document mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm.isAdvancePaymentModalActive
            ? _c("payment-entry-advance-payment-modal", {
                attrs: {
                  active: _vm.isAdvancePaymentModalActive,
                  "show-amount": false,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isAdvancePaymentModalActive = $event
                  },
                  close: _vm.closeAdvancePaymentModal,
                },
                model: {
                  value: _vm.entitySummaries,
                  callback: function ($$v) {
                    _vm.entitySummaries = $$v
                  },
                  expression: "entitySummaries",
                },
              })
            : _vm._e(),
          _vm.isLoadCreditorStatementModalActive
            ? _c(
                "creditor-list-modal",
                {
                  attrs: {
                    active: _vm.isLoadCreditorStatementModalActive,
                    "show-icon": true,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isLoadCreditorStatementModalActive = $event
                    },
                    close: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [
                  _c(
                    "p",
                    { attrs: { slot: "text-title" }, slot: "text-title" },
                    [_vm._v("Print Creditor Statements")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }